import React from 'react';

import './styles.css';

const InfoSection = ({info}) => {
  return (
    <div className="InfoSection">
      <div className="data">
        {info.map((section, index) => (
          <div className="section colab-row-space-between" key={index}>
            <div className="header colab-bold">{section.header}</div>
            <div className="text">{section.text}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default InfoSection;
